﻿import jquery from 'jquery';
import HabEvents from '../../Global/habitaclia-events';

const DynamicAds = (DTO) => {
    if (DTO && DTO.mostrarPublicidadAdsense === 'True') {
        jquery.subscribe(HabEvents.EventsEnum.ModuloLiderNoCargado, () => {
            const n = document.createElement('script');
            n.type = 'text/javascript';
            n.async = true;
            n.setAttribute('data-ad-client', 'ca-pub-2748826169855967');
            n.src = '//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';
            document.body.appendChild(n);
        });
    }
    var gpt = document.createElement('script');
    gpt.src = "https://securepubads.g.doubleclick.net/tag/js/gpt.js";
    document.head.appendChild(gpt);
    window.googletag = window.googletag || { cmd: [] };
    window.googletag.cmd.push(function () {
        var _YB = _YB || {
            ab: function () {
                return _YB.dool ? "b" : "a" + Math.floor(Math.random() * 10);
            },
            dool: Math.random() >= 0.1,
        };
        var yb_ab;
        if (Math.random() <= 0.9) {
            yb_ab = _YB.ab();
        } else {
            yb_ab = "c";
        }
        window.googletag.pubads().setTargeting("yb_ab", yb_ab);
    });
};

export default DynamicAds;
